import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexModule } from "@vp/shared/directives/flex";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormlyModule } from "@ngx-formly/core";
import { AlertModule } from "@vp/shared/components/alert";
import { ContextDisplayModule } from "@vp/shared/pipes/context-display";
import { SpinnerModule } from "@vp/shared/spinner";
import { UsersListModule } from "@vp/administration/ui/users-list";
import { EditUsersListComponent } from "./edit-users-list/edit-users-list.component";
@NgModule({
  declarations: [EditUsersListComponent],
  imports: [
    AlertModule,
    CommonModule,
    FlexModule,
    FormlyModule.forChild({
      types: [
        {
          name: "edit-users-list",
          component: EditUsersListComponent
        }
      ]
    }),
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    MatSortModule,
    ReactiveFormsModule,
    SpinnerModule,
    MatChipsModule,
    ContextDisplayModule,
    UsersListModule
  ],
  exports: []
})
export class FormlyEditUsersListModule {}
